import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { deleteData } from '../../../page/categories/categories.component';
import { deleteOPData } from '../../../page/operatingprocedure/operatingprocedure.component';
import { deleteTaskData } from '../../../page/task/task.component';
import { deleteHolidaysData } from 'src/app/page/holidays/holidays.component';
import { deleteSubTaskData } from 'src/app/page/subtask/subtask.component';
import { deleteTemTaskData } from 'src/app/page/templates/templates.component';
@Component({
  selector: 'app-delete-category-dialog',
  templateUrl: './delete-category-dialog.component.html',
  styleUrls: ['./delete-category-dialog.component.scss'],
  standalone: false,  // NOSONAR
})
export class DeleteCategoryDialogComponent implements OnInit {
  content;
  id;
  pageName;
  //im importing delete data from categories, look into it ..
  constructor(public dialogRef: MatDialogRef<DeleteCategoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: deleteData,
    @Inject(MAT_DIALOG_DATA) public dataStoreOP: deleteOPData,
    @Inject(MAT_DIALOG_DATA) public dataStoreTask: deleteTaskData,
    @Inject(MAT_DIALOG_DATA) public dataStoreHolidays: deleteHolidaysData,
    @Inject(MAT_DIALOG_DATA) public dataStoreSubTask: deleteSubTaskData,
    @Inject(MAT_DIALOG_DATA) public dataStoreTemplateTask: deleteTemTaskData
  ) {
    if (this.dataStore.page == 'task') {  // NOSONAR
      this.pageName = "Task";
      this.content = this.dataStoreTask.task_name;
      this.id = this.dataStoreTask.id;
    }
    else if (this.dataStore.page == 'category') {  // NOSONAR
      this.pageName = "Category";
      this.content = this.dataStore.category_name;
      this.id = this.dataStore.id;
    }
    else if (this.dataStore.page == 'subtask') {  // NOSONAR
      this.pageName = "Sub Task";
      this.content = this.dataStoreSubTask.subtaskName;
      this.id = this.dataStoreSubTask.subtask_id;
    }
    else if (this.dataStore.page == 'template') {  // NOSONAR
      this.pageName = "Template Task";
      this.content = this.dataStoreTemplateTask.template_task_name;
      this.id = this.dataStoreTemplateTask.template_task_id;
    }
    else if (this.dataStore.page == 'OP') {  // NOSONAR
      this.pageName = "OP";
      this.content = this.dataStoreOP.desc;
      this.id = this.dataStore.id;
    }
    else if (this.dataStore.page == 'holidays') {  // NOSONAR
      this.pageName = "Holiday";
      this.content = this.dataStoreHolidays.desc;
      this.id = this.dataStore.id;
    }
  }
  ngOnInit(): void { // NOSONAR
    //  do something 
  }
  close(): void {
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  public saveClick() {
    this.dialogRef.close({ data: this.id });
  }
}
